<p class="notification-counter">{{ counter }}</p>
